module.exports = __webpack_public_path__ + "static/img/BG@2x.815dde42.jpg";